module.exports = __webpack_public_path__ + "static/media/ChillerImg.5a022700.png";